__turbopack_context__.v({
  "mobileOnly": "TrashButton-module__0MPpCW__mobileOnly",
});
